import React from 'react';
import { useSelector } from 'react-redux';
import RowContainer from '../../common/CustomComponents/RowContainer';

const IdCards = () => {

  const tenantLayouts = useSelector(state => state.tenant.tenantLayout);
    return (
      tenantLayouts['IdCards'] && 
        <div className={tenantLayouts['IdCards'].className} id={tenantLayouts['IdCards'].id}>
        {tenantLayouts['IdCards'].sections.map((item,index) =>{
          return <RowContainer key={index} {...item} />;
        })}
        </div>
    );
};

export default IdCards;
